// eslint-disable import/no-unresolved
import { testNever } from '@gumtree/shared/src/model/generic.model';
import type {
    ActionFromReducersMapObject,
    CombinedState,
    Reducer,
    StateFromReducersMapObject,
} from 'redux';
import { RoutingPageType, pageNames } from './route-map';

// NOTE: all page types need to be added here in order for webpack
// to specifically generate chunks for them
export default (pageType: RoutingPageType) => {
    switch (pageType) {
        case pageNames.HOME:
            return import(/* webpackChunkName: "home" */ '@gumtree/home');
        case pageNames.SYI:
            return import(/* webpackChunkName: "syi" */ '@gumtree/syi');
        case pageNames.VIP:
            return import(/* webpackChunkName: "vip" */ '@gumtree/vip');
        case pageNames.SELL_MY_CAR:
            return import(/* webpackChunkName: "sell-my-car" */ '@gumtree/sell-my-car');
        case pageNames.RECRUITER_PROFILE:
            return import(/* webpackChunkName: "recruiter-profile" */ '@gumtree/recruiter-profile');
        case pageNames.JOB_PRICING:
            return import(/* webpackChunkName: "job-pricing" */ '@gumtree/job-pricing');
        case pageNames.NOT_FOUND:
            return import(/* webpackChunkName: "error-404" */ '@gumtree/error-404');
        case pageNames.MESSAGE_CENTRE:
            return import(/* webpackChunkName: "message-centre" */ '@gumtree/message-centre');
        case pageNames.REPLY_CONFIRMATION:
            return import(
                /* webpackChunkName: "reply-confirmation" */ '@gumtree/reply-confirmation'
            );
        case pageNames.STATIC_PAGES:
            return import(/* webpackChunkName: "static-pages" */ '@gumtree/static-pages');
        case pageNames.SRP:
            return import(/* webpackChunkName: "srp" */ '@gumtree/srp');
        case pageNames.SELLER_ADS:
            return import(/* webpackChunkName: "sellerads" */ '@gumtree/sellerads');
        case pageNames.BUMP_UP:
            return import(/* webpackChunkName: "bump-up" */ '@gumtree/bump-up');
        case pageNames.PROFILE:
            return import(/* webpackChunkName: "profile" */ '@gumtree/profile');
        case pageNames.CARS:
            return import(/* webpackChunkName: "cars" */ '@gumtree/cars');
        case pageNames.SERVICES_LANDING:
            return import(/* webpackChunkName: "services-landing" */ '@gumtree/services-landing');
        case pageNames.POST_A_JOB:
            return import(/* webpackChunkName: "post-a-job" */ '@gumtree/post-a-job');
        case pageNames.REQUEST_A_QUOTE:
            return import(/* webpackChunkName: "request-a-quote" */ '@gumtree/request-a-quote');
        case pageNames.POST_UPSELL:
            return import(/* webpackChunkName: "post-upsell" */ '@gumtree/post-upsell');
        case pageNames.REGISTER:
            return import(/* webpackChunkName: "register" */ '@gumtree/register');
        case pageNames.LOGIN:
            return import(/* webpackChunkName: "login" */ '@gumtree/login');
        case pageNames.PROMOTE_AD:
            return import(/* webpackChunkName: "promote-ad" */ '@gumtree/promote-ad');
        case pageNames.MANAGE_MY_ADS:
            return import(/* webpackChunkName: "manage-my-ads" */ '@gumtree/manage-my-ads');
        case pageNames.RESET_PASSWORD:
            return import(/* webpackChunkName: "reset-password" */ '@gumtree/reset-password');
        case pageNames.MANAGE_ACCOUNT:
            return import(/* webpackChunkName: "manage-account" */ '@gumtree/manage-account');
        case pageNames.FORGOTTEN_PASSWORD:
            return import(
                /* webpackChunkName: "forgotten-password" */ '@gumtree/forgotten-password'
            );
        case pageNames.LOGOUT:
            return import(/* webpackChunkName: "logout" */ '@gumtree/logout');
        case pageNames.SAVED_SEARCHES:
            return import(/* webpackChunkName: "saved-searches" */ '@gumtree/saved-searches');
        case pageNames.FAVOURITES:
            return import(/* webpackChunkName: "favourites" */ '@gumtree/favourites');
        case pageNames.REPLY_MESSAGE:
            return import(/* webpackChunkName: "reply-message" */ '@gumtree/reply-message');
        case pageNames.MANAGE_POSTAGE:
            return import(/* webpackChunkName: "manage-postage" */ '@gumtree/manage-postage');
        case pageNames.MANAGE_PAYMENT:
            return import(/* webpackChunkName: "manage-payment" */ '@gumtree/manage-payment');
        case pageNames.CREATE_ORDER:
            return import(/* webpackChunkName: "create-order" */ '@gumtree/create-order');
        case pageNames.PAYMENT_RESULT:
            return import(/* webpackChunkName: "payment-result" */ '@gumtree/payment-result');
        case pageNames.MANAGE_MY_ORDERS:
            return import(/* webpackChunkName: "manage-my-orders" */ '@gumtree/manage-my-orders');
        case pageNames.ORDER:
            return import(/* webpackChunkName: "order" */ '@gumtree/order');
        case pageNames.ORDER_SNAPSHOT:
            return import(/* webpackChunkName: "order-snapshot" */ '@gumtree/order-snapshot');
        case pageNames.SHIPPING_LABEL:
            return import(/* webpackChunkName: "shipping-label" */ '@gumtree/shipping-label');
        case pageNames.ACTIVATE_SELLER_ACCOUNT:
            return import(
                /* webpackChunkName: "activate-seller-account" */ '@gumtree/activate-seller-account'
            );
        case pageNames.REPORT_AN_ISSUE:
            return import(/* webpackChunkName: "report-an-issue" */ '@gumtree/report-an-issue');
        case pageNames.VIP_SEO:
            return import(/* webpackChunkName: "vip-seo" */ '@gumtree/vip-seo');
        case pageNames.QUESTION_ANSWERS:
            return import(/* webpackChunkName: "question-answers" */ '@gumtree/question-answers');
        case pageNames.SYI_NEXT:
            return import(/* webpackChunkName: "syi-next" */ '@gumtree/syi-next');
        case pageNames.SERVER_500:
            return import(/* webpackChunkName: "error-500" */ '@gumtree/error-500');
        case pageNames.SEO_TOPIC_PAGE:
            return import(/* webpackChunkName: "seo-topic-page" */ '@gumtree/seo-topic-page');
        default:
            throw new Error(`Cannot load bundle for page type: ${testNever(pageType) && pageType}`);
    }
};

/**
 * Typescript does not infer return type of above properly (missing summands),
 * so we define it manually.
 */
export type AppAndReducersType =
    | typeof import(/* webpackChunkName: "home" */ '@gumtree/home')
    | typeof import(/* webpackChunkName: "syi" */ '@gumtree/syi')
    | typeof import(/* webpackChunkName: "vip" */ '@gumtree/vip')
    | typeof import(/* webpackChunkName: "sell-my-car" */ '@gumtree/sell-my-car')
    | typeof import(/* webpackChunkName: "recruiter-profile" */ '@gumtree/recruiter-profile')
    | typeof import(/* webpackChunkName: "job-pricing" */ '@gumtree/job-pricing')
    | typeof import(/* webpackChunkName: "error-404" */ '@gumtree/error-404')
    | typeof import(/* webpackChunkName: "message-centre" */ '@gumtree/message-centre')
    | typeof import(/* webpackChunkName: "reply-confirmation" */ '@gumtree/reply-confirmation')
    | typeof import(/* webpackChunkName: "static-pages" */ '@gumtree/static-pages')
    | typeof import(/* webpackChunkName: "srp" */ '@gumtree/srp')
    | typeof import(/* webpackChunkName: "sellerads" */ '@gumtree/sellerads')
    | typeof import(/* webpackChunkName: "bump-up" */ '@gumtree/bump-up')
    | typeof import(/* webpackChunkName: "profile" */ '@gumtree/profile')
    | typeof import(/* webpackChunkName: "cars" */ '@gumtree/cars')
    | typeof import(/* webpackChunkName: "services-landing" */ '@gumtree/services-landing')
    | typeof import(/* webpackChunkName: "post-a-job" */ '@gumtree/post-a-job')
    | typeof import(/* webpackChunkName: "request-a-quote" */ '@gumtree/request-a-quote')
    | typeof import(/* webpackChunkName: "post-upsell" */ '@gumtree/post-upsell')
    | typeof import(/* webpackChunkName: "register" */ '@gumtree/register')
    | typeof import(/* webpackChunkName: "login" */ '@gumtree/login')
    | typeof import(/* webpackChunkName: "promote-ad" */ '@gumtree/promote-ad')
    | typeof import(/* webpackChunkName: "manage-my-ads" */ '@gumtree/manage-my-ads')
    | typeof import(/* webpackChunkName: "reset-password" */ '@gumtree/reset-password')
    | typeof import(/* webpackChunkName: "manage-account" */ '@gumtree/manage-account')
    | typeof import(/* webpackChunkName: "forgotten-password" */ '@gumtree/forgotten-password')
    | typeof import(/* webpackChunkName: "logout" */ '@gumtree/logout')
    | typeof import(/* webpackChunkName: "saved-searches" */ '@gumtree/saved-searches')
    | typeof import(/* webpackChunkName: "favourites" */ '@gumtree/favourites')
    | typeof import(/* webpackChunkName: "reply-message" */ '@gumtree/reply-message')
    | typeof import(/* webpackChunkName: "manage-postage" */ '@gumtree/manage-postage')
    | typeof import(/* webpackChunkName: "manage-payment" */ '@gumtree/manage-payment')
    | typeof import(/* webpackChunkName: "create-order" */ '@gumtree/create-order')
    | typeof import(/* webpackChunkName: "payment-result" */ '@gumtree/payment-result')
    | typeof import(/* webpackChunkName: "manage-my-orders" */ '@gumtree/manage-my-orders')
    | typeof import(/* webpackChunkName: "order" */ '@gumtree/order')
    | typeof import(/* webpackChunkName: "order-snapshot" */ '@gumtree/order-snapshot')
    | typeof import(/* webpackChunkName: "shipping-label" */ '@gumtree/shipping-label')
    | typeof import(/* webpackChunkName: "activate-seller-account" */ '@gumtree/activate-seller-account')
    | typeof import(/* webpackChunkName: "report-an-issue" */ '@gumtree/report-an-issue')
    | typeof import(/* webpackChunkName: "vip-seo" */ '@gumtree/vip-seo')
    | typeof import(/* webpackChunkName: "question-answers" */ '@gumtree/question-answers')
    | typeof import(/* webpackChunkName: "syi-next" */ '@gumtree/syi-next')
    | typeof import(/* webpackChunkName: "error-500" */ '@gumtree/error-500')
    | typeof import(/* webpackChunkName: "seo-topic-page" */ '@gumtree/seo-topic-page');

export type AppsType = Extract<AppAndReducersType, { App: any }>['App'];
export type ReducersType = Extract<AppAndReducersType, { reducers: any }>['reducers'];

export type CombinedReducerType = Reducer<
    CombinedState<StateFromReducersMapObject<ReducersType>>,
    ActionFromReducersMapObject<ReducersType>
>;

export type PagesState = ReturnType<CombinedReducerType>;
